module.exports = __webpack_public_path__ + "img/fuwu1.60dc401b.png";